import React, { useCallback, useEffect, useState } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { useTranslation } from 'react-i18next'

import Quests from '../components/quests/Quests'
import { QUEST_PROFILE_DISPATCH } from '../store/reducers/quest/quest'
import { changeQuestState, updateQuest } from '../store/actions/quest'
import {
  QUEST_FILTER_TYPE,
  QUEST_VERIFY_DISABLE_TIME
} from '../util/quest.helpers'

const QuestsContainer = ({
  questProfile,
  changeQuestState,
  updateQuest,
  tokenProfile,
  ...restProps
}) => {
  const { t } = useTranslation()

  useEffect(() => {
    return () => {
      changeQuestState(
        QUEST_PROFILE_DISPATCH.FILTER_BY,
        QUEST_FILTER_TYPE.ACTIVE
      )
    }
  }, [])

  const [enableFulfill, setEnableFulfill] = useState({})
  const [selected, setSelected] = useState(null)

  const handleFulfillQuest = useCallback((id) => {
    changeQuestState(QUEST_PROFILE_DISPATCH.ERROR, {})
    setEnableFulfill({})
    setTimeout(() => {
      setEnableFulfill({ [id]: true })
    }, QUEST_VERIFY_DISABLE_TIME)
  }, [])

  const handleChangeFilterMenu = ({ value }) => {
    changeQuestState(QUEST_PROFILE_DISPATCH.FILTER_BY, value)
  }

  const handleVerifyAndClaim = useCallback((id) => {
    changeQuestState(QUEST_PROFILE_DISPATCH.ERROR, {})
    setEnableFulfill({})
    setSelected(id)
    updateQuest(id)
  }, [])

  return (
    <Quests
      t={t}
      onChangeFilterMenu={handleChangeFilterMenu}
      questProfile={questProfile}
      tokenProfile={tokenProfile}
      onFulfillQuest={handleFulfillQuest}
      onVerifyAndClaim={handleVerifyAndClaim}
      enableFulfill={enableFulfill}
      selected={selected}
      {...restProps}
    />
  )
}

const mapStateToProps = ({ mainReducer, questReducer }) => {
  const { tokenProfile } = mainReducer
  const { questProfile } = questReducer
  return {
    tokenProfile,
    questProfile
  }
}

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      changeQuestState,
      updateQuest
    },
    dispatch
  )

export default connect(mapStateToProps, mapDispatchToProps)(QuestsContainer)
